import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";

// const root = ReactDOM.render(document.getElementById("root"));
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
